export default __webpack_public_path__ + "static/media/ThomasWijnands.d6f94d07.pdf";